<template>
  <!-- 销售订单中待送订单、待确认订单打印 -->
  <div v-loading="loading">
    <el-row class="tac" type="flex">
      <el-col :span="24" class="layout-header">
        <div class="layout-header-logo">
          <img :src="lkdLogo" style="height: 50px;margin-top: 5px">
        </div>
        <span style="margin-right: 150px;color: white">打印预览&nbsp;&nbsp;<i class="el-icon-close" @click="back" style="color: white"></i></span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2" :offset="4" style="margin-top: 20px">
        <h4 style="text-align: center">打印预览</h4>
      </el-col>
      <el-col :span="2" :offset="14" style="margin-top: 20px">
        <i class="el-icon-close" @click="back"></i>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2" :offset="22">
        <el-button size="small" style="margin-right:30px;margin-bottom: 20px" type="danger" @click="printPreview()">打印
        </el-button>
      </el-col>
    </el-row>
    <div id="subOutputRank-print" style="margin: auto">
      <template v-for="item in tableData">
        <!-- <v-tax :tableData="item" :key="item.ORDER_DETAIL_ID" :headerData="topData" :manager="managername" :supplier="printName" :ASSOCIATED_PERSON="ASSOCIATED_PERSON"  v-if="isShortDocFlag == 2"></v-tax> -->
        <s-tax :tableData="item" :key="item.ORDER_DETAIL_ID" :headerData="topData" :manager="managername" :supplier="printName"
          :ASSOCIATED_PERSON="ASSOCIATED_PERSON" :isRemarks="isremarks"></s-tax>
      </template>
    </div>
    <el-row>
      <el-col :span="2" :offset="22">
        <el-button size="small" style="margin-right:30px;margin-bottom: 20px" type="danger" @click="printPreview()">打印
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  notOrderDetailFun, updatePrintOrderFun, updatePrintTimeFun, supplierCusNewDetailFun,
} from 'api/sellOrder';
import http from '@/assets/common/http';
// import VTax from '@/components/orderPrint/sellOrderCustomPrintTax';
import STax from '@/components/orderPrint/toBeConfirmePrintShortTax';

export default {
  data() {
    return {
      loading: true,
      managername: sessionStorage.getItem('name'),
      tableData: [],
      topData: [],
      toBeForm: JSON.parse(localStorage.getItem('toBeForm')),
      printName: sessionStorage.getItem('supplierName'),
      countFlag: sessionStorage.getItem('countFlag'), // 0表示打印订购数量，1表示打印送货数量
      isShortDocFlag: 1, // 长短单子标识，0代表长单子，1代表短单子
      printRealFlag: sessionStorage.getItem('printRealFlag'), // 是否打印实收：0表示不打印，1表述打印
      printLength: 30,
      pageRouter: sessionStorage.getItem('pageRouter'),
      isremarks: this.$route.params.remarks,
      ASSOCIATED_PERSON: [],
      lkdLogo: this.$util.publicLogo() || '',
      useTemplate: 0,
      templateUseKg: 1,
      isThirdParty: this.$route.params.isThirdParty,
    };
  },
  components: {
    // VTax,
    STax,
  },
  async created() {
    const tcId = sessionStorage.getItem('tcId');
    if (this.countFlag == 1 && tcId == 1730) {
      this.$message.show({
        text: '温馨提示：为保障服务质量，请贵校认真检查所配送物品质量及数量，确认无误后签字，谢谢配合！',
        type: 'warning',
      });
    }
    await this.queryForm();
    this.queryOrderDetailListData();
  },
  destroyed() {
    sessionStorage.removeItem('isSummaryPrinting');
  },
  methods: {
    back() {
      window.history.go(-1);
      sessionStorage.removeItem('payableName');
    },
    async queryForm() {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        IS_SUPPLIER_CLIENT: 0,
        TC_ID: sessionStorage.getItem('TEM_TCID'),
      };
      await http.post(params).then((result) => {
        const templateContent = result[0].TEMPLATE_CONTENT.find(({ TEMPLATE_TYPE }) => TEMPLATE_TYPE == 2);
        this.useTemplate = result[0].USE_PRINT_TEMPLATE;
        if (templateContent) {
          this.isShortDocFlag = templateContent.TYPE;
          this.templateUseKg = this.useTemplate ? templateContent.NONSTANDARD_PRODUCT_USE_KG : 1;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    async queryOrderDetailListData() {
      if (Number(sessionStorage.getItem('orderPrintStatus')) == 4) {
        const params = {
          ORDER_ID: sessionStorage.getItem('orderId'),
        };
        supplierCusNewDetailFun(params).then((result) => {
          if (result[0].TITLE[0].AGENT) {
            sessionStorage.setItem('AGENT', result[0].TITLE[0].AGENT);
          } else {
            sessionStorage.setItem('AGENT', 0);
          }
          this.showStatus = result[0].TITLE[0].STATUS;
          const res = result.length > 0 ? result[0].DETAIL : [];
          for (let i = 0; i < res.length; i++) {
            res.forEach((item, index) => {
              item.ID = index + 1;
            });
          }
          this.topData.push(...result[0].TITLE);
          this.topData[0].ORDER_ID = sessionStorage.getItem('orderId');
          this.loading = false;
          const len = res.length;
          const n = 30; // 假设每行显示4个
          const lineNum = len % n === 0 ? len / n : Math.floor((len / n) + 1);
          const data = [];
          for (let i = 0; i < lineNum; i++) {
            const temp = res.slice(i * n, i * n + n);
            data.push(temp);
            data.forEach((item, index) => {
              item.currentPage = index + 1;
              item.totalPage = lineNum;
            });
            this.tableData = data;
            if (sessionStorage.getItem('realCountFlag') == 0) this.tableData[0].forEach((item) => item.REAL_COUNT = '');
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else if (Number(sessionStorage.getItem('isSummaryPrinting')) == 1) { // isSummaryPrinting 是亦芙德 德汇总打印
        let 拼接结果 = [];
        let 拷贝一份result = [];
        let res = [];
        let 最终结果 = [];
        const resList = [];

        for (const ITEM of JSON.parse(sessionStorage.getItem('所要打印的订单列表'))) {
          const params = {
            ID: Number(ITEM),
            FILTER_FLAG: 0,
            GYS_ID: sessionStorage.getItem('tcId'),
            Supplier_Third_Type: 1,
          };
          try {
            resList.push(await notOrderDetailFun(params));
          } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
          }
        }
        for (const ITEM of resList) {
          const 上一次结果 = 拼接结果;
          拼接结果 = 上一次结果.concat(ITEM[0].DETAIL);
          const map = {};
          拼接结果.forEach((item) => {
            const key = `${item.PRODUCT_CODE}-${item.PROJECT_PRICE}`;
            if (map[key]) {
              map[key].REAL_COUNT = parseFloat(map[key].REAL_COUNT) + parseFloat(item.REAL_COUNT);
              map[key].NEED_COUNT = parseFloat(map[key].NEED_COUNT) + parseFloat(item.NEED_COUNT);
              map[key].PRODUCT_COUNT = parseFloat(map[key].PRODUCT_COUNT) + parseFloat(item.PRODUCT_COUNT);
              map[key].SUPPLIER_TOTAL_FEE = parseFloat(map[key].SUPPLIER_TOTAL_FEE) + parseFloat(item.SUPPLIER_TOTAL_FEE);
              map[key].SUPPLIER_REAL_FEE = parseFloat(map[key].SUPPLIER_REAL_FEE) + parseFloat(item.SUPPLIER_REAL_FEE);
              map[key].PROJECT_REAL_FEE = parseFloat(map[key].PROJECT_REAL_FEE) + parseFloat(item.PROJECT_REAL_FEE);
              map[key].PROJECT_TOTAL_FEE = parseFloat(map[key].PROJECT_TOTAL_FEE) + parseFloat(item.PROJECT_TOTAL_FEE);
            } else {
              map[key] = { ...item, REAL_COUNT: parseFloat(item.REAL_COUNT).toString() };
            }
          });
          最终结果 = Object.values(map);
          拷贝一份result = ITEM;
        }
        this.ASSOCIATED_PERSON = 拷贝一份result[0].ASSOCIATED_PERSON;

        if (this.isShortDocFlag == 1) {
          res = 最终结果.filter((item) => Number(item.NEED_COUNT) !== 0);
        } else {
          res = 最终结果;
        }
        res = res.map((item, index) => ({ ...item, ID: index + 1 }));
        this.topData.push(...拷贝一份result[0].TITLE);
        this.topData[0].ORDER_ID = JSON.parse(sessionStorage.getItem('所要打印的订单列表'));
        this.topData[0].ORDER_CODE = (JSON.parse(sessionStorage.getItem('所要打印的订单列表'))).join(',');
        this.loading = false;
        const len = res.length;
        // 判断如果是段打印，那么一张纸显示15条数据
        if (this.isShortDocFlag == 2) {
          this.printLength = 30;
        } else {
          this.printLength = 15;
        }
        const n = this.printLength; // 假设每行显示4个
        const lineNum = len % n === 0 ? len / n : Math.floor((len / n) + 1);
        const data = [];
        let totalSupplierFee = 0;
        for (let i = 0; i < lineNum; i++) {
          data.push(res.slice(i * n, i * n + n));
        }

        data.forEach((item, index) => {
          totalSupplierFee = 0;
          item.forEach((itemTwo) => {
            if (this.printRealFlag == 1) {
              // 只要打印实收，那么显示的总金额即为项目点实收总金额
              totalSupplierFee += Number(itemTwo.PROJECT_REAL_FEE);
            } else {
              // 0表示打印订购数量，1表示打印送货数量
              if (this.countFlag == 0) {
                totalSupplierFee += Number(itemTwo.PROJECT_TOTAL_FEE);
              } else if (this.countFlag == 1) {
                itemTwo.needFee = Number(itemTwo.NEED_COUNT) * Number(itemTwo.PROJECT_PRICE);
                totalSupplierFee += Number(Math.round(Number(itemTwo.needFee) * 100)) / 100;
              } else {
                totalSupplierFee += Number(itemTwo.PROJECT_REAL_FEE);
              }
            }
          });
          item.currentPage = index + 1;
          item.totalPage = lineNum;
          item.pageFee = Number(Math.round(Number(totalSupplierFee) * 100)) / 100;
        });
        this.tableData = data;
      } else {
        const params = {
          ID: sessionStorage.getItem('orderId'),
        };
        if (this.isThirdParty) {
          params.Supplier_Third_Type = 1;
          params.FILTER_FLAG = 0;
          params.GYS_ID = sessionStorage.getItem('tcId');
        }
        if (this.useTemplate) {
          params.USE_TEMPLATE = this.useTemplate;
          params.TEMPLATE_USE_KG = this.templateUseKg;
        }
        notOrderDetailFun(params).then((result) => {
          let res = [];

          this.ASSOCIATED_PERSON = result[0].ASSOCIATED_PERSON;
          // 判断如果是短打印，那么送货数量为0的商品不进行打印
          if (this.isShortDocFlag == 1) {
            if (Number(sessionStorage.getItem('tcId')) == 100) {
              res = result[0].DETAIL;
            } else {
              res = result[0].DETAIL.filter((item) => Number(item.NEED_COUNT) !== 0);
            }
          } else {
            res = result.length > 0 ? result[0].DETAIL : [];
          }
          for (let i = 0; i < res.length; i++) {
            res.forEach((item, index) => {
              item.ID = index + 1;
            });
          }
          this.topData.push(...result[0].TITLE);
          this.topData[0].ORDER_ID = sessionStorage.getItem('orderId');
          this.loading = false;
          const len = res.length;
          // 判断如果是段打印，那么一张纸显示15条数据
          if (this.isShortDocFlag == 2) {
            this.printLength = 30;
          } else {
            this.printLength = 15;
          }
          const n = this.printLength; // 假设每行显示4个
          const lineNum = len % n === 0 ? len / n : Math.floor((len / n) + 1);
          const data = [];
          let totalSupplierFee = 0;
          for (let i = 0; i < lineNum; i++) {
            data.push(res.slice(i * n, i * n + n));
          }
          data.forEach((item, index) => {
            totalSupplierFee = 0;
            item.forEach((itemTwo) => {
              if (this.printRealFlag == 1) {
                // 只要打印实收，那么显示的总金额即为项目点实收总金额
                totalSupplierFee += Number(itemTwo.PROJECT_REAL_FEE);
              } else {
                // 0表示打印订购数量，1表示打印送货数量
                if (this.countFlag == 0) {
                  totalSupplierFee += Number(itemTwo.PROJECT_TOTAL_FEE);
                } else if (this.countFlag == 1) {
                  itemTwo.needFee = Number(itemTwo.NEED_COUNT) * Number(itemTwo.PROJECT_PRICE);
                  totalSupplierFee += Number(Math.round(Number(itemTwo.needFee) * 100)) / 100;
                } else {
                  totalSupplierFee += Number(itemTwo.PROJECT_REAL_FEE);
                }
              }
            });
            item.currentPage = index + 1;
            item.totalPage = lineNum;
            item.pageFee = Number(Math.round(Number(totalSupplierFee) * 100)) / 100;
          });
          this.tableData = data;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    // 打印
    printPreview() {
      if (this.topData[0].STATUS == 1 || this.topData[0].STATUS == 2) {
        const data = {
          ORDER_ID: Number(sessionStorage.getItem('orderId')),
        };
        // 如果是待送订单需要改变订单状态
        updatePrintOrderFun(data).then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          const subOutputRankPrint = document.getElementById('subOutputRank-print');
          const newContent = subOutputRankPrint.innerHTML;
          const oldContent = document.body.innerHTML;
          document.body.innerHTML = newContent;
          window.print();
          window.location.reload();
          document.body.innerHTML = oldContent;
          this.$router.push({ name: this.pageRouter });
          window.location.reload();
          return false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        const params = {
          ORDER_ID: Number(sessionStorage.getItem('orderId')),
        };
        // 改变打印次数
        updatePrintTimeFun(params).then((res) => {
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
        const subOutputRankPrint = document.getElementById('subOutputRank-print');
        const newContent = subOutputRankPrint.innerHTML;
        const oldContent = document.body.innerHTML;
        document.body.innerHTML = newContent;
        window.print();
        window.location.reload();
        document.body.innerHTML = oldContent;
        this.$router.push({ name: this.pageRouter });
        window.location.reload();
        return false;
      }
    },
  },
};
</script>
<style scoped>
.ma img {
  width: 105px;
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}

#subOutputRank-print {
  width: 284mm;
}

@media print {
  .page-break {
    page-break-after: always;
  }
}

.layout-header {
  z-index: 10;
  position: fixed;
  width: 100%;
  background: linear-gradient(#373737, #464c5b);
  line-height: 60px;
  text-align: right;
  border-bottom: 1px solid #505664;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.layout-header-logo {
  height: 60px;
  width: 210px;
  float: left;
}

.layout-header-logo img {
  width: 90%;
  margin-right: 5%;
  height: 60px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/toBeConfirmePrintDetail.vue